import { SolIcon } from '@sol/icons';
import { navbar } from './app.navbar';
import { SolApp } from '@sol/components';
import { SolCatalogRouteId } from './models/sol-catalog-route-id';

export const apps: SolApp[] = [
  SolApp.ofExternal(
    SolCatalogRouteId.app_platform,
    'Platform',
    SolIcon.application,
    'Client apps',
    [], // Todo
  ),
  SolApp.ofExternal(
    SolCatalogRouteId.app_partner,
    'Partner',
    SolIcon.users,
    'Client apps',
    [], // Todo
  ),
  SolApp.ofExternal(
    SolCatalogRouteId.app_admin,
    'Administration',
    SolIcon.internal,
    'Client apps',
    [], // Todo
  ),
  SolApp.ofInternal(
    SolCatalogRouteId.app_catalog,
    'Sól Catalog',
    SolIcon.application,
    'Internal apps',
    navbar,
    [], // Todo
  ),
];
